import React, { useState, forwardRef, useEffect } from "react";
import {
  Paper,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  CircularProgress,
} from "@mui/material";

// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";

// import "@fullcalendar/core/main.css";
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from "date-fns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useSelector } from "react-redux";

import {
  createCalendarEvent,
  deleteCalendarEventById,
  getCalendarEventsByMonth,
  updateCalendarEventById,
} from "../../api/calendar.js";
import useSnackbar from "../../hooks/useSnackbar.js";
import useErrorHandler from "../../hooks/useErrorHandler";

// const tempEvents = [
//     { title: "All Day Event", start: getDate("YEAR-MONTH-01"), id: 1 },
//     {
//         id: 2,
//         title: "Long Event",
//         start: getDate("YEAR-MONTH-07"),
//         end: getDate("YEAR-MONTH-10")
//     },
//     {
//         id: 3,
//         groupId: "999",
//         title: "Repeating Event",
//         start: getDate("YEAR-MONTH-09T16:00:00+00:00")
//     },
//     {
//         id: 4,
//         groupId: "999",
//         title: "Repeating Event",
//         start: getDate("YEAR-MONTH-16T16:00:00+00:00")
//     },
//     {
//         id: 5,
//         title: "Conference",
//         start: getDate("YEAR-MONTH-17"),
//         end: getDate("YEAR-MONTH-19")
//     },
//     {
//         id: 6,
//         title: "Meeting",
//         start: getDate("YEAR-MONTH-18T10:30:00+00:00"),
//         end: getDate("YEAR-MONTH-18T12:30:00+00:00")
//     },
//     { title: "Lunch", start: getDate("YEAR-MONTH-18T12:00:00+00:00"), id: 7 },
//     { title: "Birthday Party", start: getDate("YEAR-MONTH-19T07:00:00+00:00"), id: 8 },
//     { title: "Meeting", start: getDate("YEAR-MONTH-18T14:30:00+00:00"), id: 9 },
//     { title: "Happy Hour", start: getDate("YEAR-MONTH-18T17:30:00+00:00"), id: 10 },
//     { title: "Dinner", start: getDate("YEAR-MONTH-18T20:00:00+00:00"), id: 11 }
// ];

export default function EventCalendar() {
  const [eventDialogOpen, setEventDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("CREATE");
  const [selectedEvent, setSelectedEvent] = useState(0);
  const [events, setEvents] = useState([]);
  const { data: user } = useSelector((state) => state.user);
  const [thisMonth, setThisMonth] = useState(new Date().getMonth() + 1);
  const [thisYear, setThisYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();

  const onAddEventClick = () => {
    setDialogMode("CREATE");
    setEventDialogOpen(true);
  };

  const onCalendarEventClick = ({ event }) => {
    setSelectedEvent(events.find((e) => e.id == event.id));
    setDialogMode("EDIT");
    setEventDialogOpen(true);
  };

  async function onEventAdd(data) {
    try {
      // api call here
      const res = await createCalendarEvent(user.token, data);
      setEvents((prev) => [...prev, { ...data, id: res.data.newEventId }]);
      setEventDialogOpen(false);
      snackbar.showSuccess("Event Added.");
    } catch (error) {
      handleError(error);
    }
  }

  async function onEventUpdate(id, data) {
    try {
      // api call
      await updateCalendarEventById(
        user.token,
        id,
        allowedUpdatableEventData(data)
      );
      setEvents((prev) =>
        prev.map((e) => {
          if (e.id == id) return data;
          return e;
        })
      );
      setEventDialogOpen(false);
      snackbar.showSuccess("Event Updated.");
    } catch (error) {
      handleError(error);
    }
  }

  async function onEventDelete(id) {
    try {
      // api call here
      await deleteCalendarEventById(user.token, id);
      setEvents((prev) => prev.filter((e) => e.id != id));
      setEventDialogOpen(false);
      snackbar.showSuccess("Event Deleted.");
    } catch (error) {
      handleError(error);
    }
  }

  useEffect(() => {
    if (!user.token) return;
    setLoading(true);
    getCalendarEventsByMonth(user.token, thisMonth, thisYear)
      .then(({ data }) => {
        // let events = praseEvents(data.data)
        setEvents(data.data);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user.token, thisMonth, thisYear]);

  function handleDates(rangeInfo) {
    const [year, month] = rangeInfo.startStr.split("-");
    setThisMonth(parseInt(month) + 1);
    setThisYear(parseInt(year));
  }

  return (
    <>
      <Paper className="odr-card">
        <Box
          mb={0}
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Button
            variant="contained"
            size="large"
            onClick={onAddEventClick}
            className="blue-button"
          >
            Add Event
          </Button>
          {loading ? <CircularProgress /> : <></>}
        </Box>
        <Box sx={{ px: 3 }}>
          <FullCalendar
            defaultView="dayGridMonth"
            header={{
              left: "prev,next",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            plugins={[dayGridPlugin, timeGridPlugin]}
            events={events}
            eventClick={onCalendarEventClick}
            datesSet={handleDates}
          />
        </Box>
        <EventDialog
          open={eventDialogOpen}
          setOpen={setEventDialogOpen}
          onEventAdd={onEventAdd}
          mode={dialogMode}
          onEventUpdate={onEventUpdate}
          onEventDelete={onEventDelete}
          selectedEvent={selectedEvent}
        />
      </Paper>
    </>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const emptyEventData = {
  title: "",
  // link: "",
  // allDay: false,
  start: "",
  end: "",
};

function EventDialog({
  open,
  setOpen,
  onEventAdd,
  mode,
  selectedEvent,
  onEventUpdate,
  onEventDelete,
}) {
  const { data: user } = useSelector((state) => state.user);
  const [data, setData] = useState(emptyEventData);
  const isMeeting = /meeting/gi.test(data.type);

  const handleDataChange = ({ target }) => {
    setData((prev) => ({ ...prev, [target.name]: target.value }));
  };

  useEffect(() => {
    if (mode === "CREATE") {
      setData(emptyEventData);
    } else {
      setData(selectedEvent);
    }
  }, [mode, open]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleEventSubmit = (e) => {
    e.preventDefault();
    if (mode === "CREATE") {
      if (allDay) {
        onEventAdd({
          title: data.title,
          start: new Date(data.start.slice(0, 10)).toISOString(),
          end: data.end ? new Date(data.end.slice(0, 10)).toISOString() : "",
        });
      } else {
        onEventAdd(data);
      }
    } else onEventUpdate(data.id, data);
  };

  const handleEventDelete = () => {
    onEventDelete(data.id);
  };

  const [allDay, setAllDay] = useState(false);
  const handleTypeChange = () => {
    setData((prev) => ({ ...prev, start: "", end: "" }));
    setAllDay((prev) => !prev);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      //onClose={handleClose}
      onClose={() => {
        
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <Box component="form" onSubmit={handleEventSubmit}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pr={3}
        >
          <DialogTitle className="heading-title">
            {mode === "CREATE" ? "Add" : "Edit"} Event
          </DialogTitle>
          <Typography>
            {isMeeting ? data.type.split("-").join(" ") : ""}
          </Typography>
        </Box>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={12} sm={12} xl={12}>
              <TextField
                label="Title"
                name="title"
                value={data.title}
                disabled={isMeeting}
                onChange={handleDataChange}
                size="small"
                fullWidth
                required
              />
            </Grid>
            {/* <Grid item md={12} sm={12} xl={12}>
                            <TextField label="Link (Optional)" name="url" value={data.url}
                                onChange={handleDataChange} size="small" fullWidth
                            />
                        </Grid> */}
            <Grid item md={12} sm={12} xl={12} ml={1}>
              <FormControlLabel
                disabled={isMeeting}
                label="All Day Event"
                name="allDay"
                control={<Checkbox onChange={handleTypeChange} />}
                checked={allDay}
              />
            </Grid>
            {allDay ? (
              <>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Start Date"
                      required
                      disabled={isMeeting}
                      minDateTime={parseISO(new Date().toISOString())}
                      value={parseISO(data.start)}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "start",
                            value: newValue.toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="End Date"
                      disabled={isMeeting}
                      minDateTime={parseISO(
                        data.start || new Date().toISOString()
                      )}
                      value={parseISO(data.end)}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "end",
                            value: newValue.toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                          helperText="Ignore if one day event only"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      label="Start At"
                      required
                      disabled={isMeeting}
                      minDateTime={parseISO(new Date().toISOString())}
                      value={parseISO(data.start)}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "start",
                            value: newValue.toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      label="End At"
                      required
                      disabled={isMeeting}
                      minDateTime={parseISO(
                        data.start || new Date().toISOString()
                      )}
                      value={parseISO(data.end)}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "end",
                            value: newValue.toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            size="large"
            className="black-border-button"
          >
            Cancel
          </Button>
          {isMeeting ? (
            <></>
          ) : (
            <Button
              disabled={/^trial_user$/i.test(user.roles) ? true : false}
              variant="contained"
              className="blue-button"
              size="large"
              type="submit"
            >
              {mode === "CREATE" ? "Add" : "Update"}
            </Button>
          )}
          {mode === "EDIT" && !isMeeting ? (
            <Button
              variant="text"
              color="error"
              onClick={handleEventDelete}
              size="large"
              className="red-boder-button"
              disabled={/^trial_user$/i.test(user.roles) ? true : false}
            >
              Delete
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}

function allowedUpdatableEventData(data) {
  return {
    title: data.title,
    start: data.start,
    end: data.end,
  };
}
